import { hot } from "react-hot-loader";

import React, { useEffect, useState } from "react";
import calloutCardThemes from "@streeteasy/design-system/callout-card/constants/calloutCardThemes";
import { VerticalCalloutCardButton } from "@streeteasy/design-system/callout-card/VerticalCalloutCard";
import { func, number, oneOfType, shape, string } from "prop-types";

import ScheduleShowing from "../../assets/ScheduleShowing.svg";
import urlServiceImpl from "../../services/urlService";
import * as S from "./styled";

const ScheduleShowingButton = ({ saleId, scheduleShowingUrl, urlService }) => {
  const [schedulingUrl, setSchedulingUrl] = useState(scheduleShowingUrl);
  const bannerDescription = `From request to confirmation, ShowingTime is a tool that helps you save time and coordinate the details at no cost.`;

  useEffect(() => {
    if (window.dataLayer) {
      const canPush =
        window.dataLayer.filter(
          e => e.event_action === "impression_for_schedule_showing"
        ).length === 0;

      if (canPush) {
        window.dataLayer.push({
          event: "custom_event",
          event_category: "sales_show",
          event_action: "impression_for_schedule_showing",
          event_label: `listing_id=${saleId}`
        });
      }
    }
  }, []);

  const handleClick = async e => {
    e.preventDefault();

    let url = schedulingUrl;
    const expired = await urlService.checkExpiredPeriod(scheduleShowingUrl);

    if (expired) {
      url = await urlService.generateSchedulingUrl(saleId);
      setSchedulingUrl(url);
    }

    const newWindow = global.open(url, "_blank", "noopener,noreferrer");
    if (newWindow) newWindow.opener = null;
  };

  const handleAnalyticsScheduleShowingClick = e => {
    if (window.dataLayer) {
      window.dataLayer.push({
        event: "custom_event",
        event_category: "sales_show",
        event_action: "schedule_showing",
        event_label: `listing_id=${saleId}`
      });
    }
    handleClick(e);
  };

  return (
    <VerticalCalloutCardButton
      callToActionCopy={
        <>
          <S.LinkOutIcon />
          <span>Schedule showing</span>
        </>
      }
      data-qa="schedule-showing-time"
      description={bannerDescription}
      headline="Schedule showing"
      legalCopy={
        <>
          <span>
            To speak directly with an Appointment Specialist to schedule a
            showing, call 855-746-9001.
          </span>
          <br />
          <br />
          <img alt="Powered by ShowingTime" src={ScheduleShowing} />
        </>
      }
      onClick={e => handleAnalyticsScheduleShowingClick(e)}
      theme={calloutCardThemes.ORANGE}
      type="button"
    />
  );
};

ScheduleShowingButton.propTypes = {
  saleId: oneOfType([string, number]).isRequired,
  scheduleShowingUrl: string.isRequired,
  urlService: shape({
    checkExpiredPeriod: func.isRequired,
    generateSchedulingUrl: func.isRequired
  })
};

ScheduleShowingButton.defaultProps = {
  urlService: urlServiceImpl
};

export default hot(module)(ScheduleShowingButton);
